import type {NodeClassImpl} from "#template/runtime-graph/types"
import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {InterfaceDescriptor, InterfaceId} from "#template/interface-descriptors"
import {wrapInterfaceId} from "#template/interface-descriptors"

const TD = TypeDescriptors

const filterAndWrapInterfaceDescriptor = {
    interface: TD.inlet(TD.Array(TD.Identity<InterfaceDescriptor<unknown>>())),
    wrapWithId: TD.inlet(TD.Primitive<InterfaceId>()),
    claimedInputIds: TD.inlet(TD.Array(TD.Primitive<InterfaceId>())),
    includeClaimed: TD.inlet(TD.Boolean),
    output: TD.outlet(TD.Array(TD.Identity<InterfaceDescriptor<unknown>>())),
}

export class FilterAndWrapInterface implements NodeClassImpl<typeof filterAndWrapInterfaceDescriptor, typeof FilterAndWrapInterface> {
    static descriptor = filterAndWrapInterfaceDescriptor
    static uniqueName = "FilterAndWrapInterface"
    interface!: Inlet<InterfaceDescriptor<unknown>[]>
    wrapWithId!: Inlet<InterfaceId>
    claimedInputIds!: Inlet<InterfaceId[]>
    includeClaimed!: Inlet<boolean>
    output!: Outlet<InterfaceDescriptor<unknown>[]>

    run() {
        if (this.interface === NotReady || this.wrapWithId === NotReady || this.claimedInputIds === NotReady || this.includeClaimed === NotReady) {
            this.output.emitIfChanged(NotReady)
            return
        }
        const wrapWithId = this.wrapWithId

        const wrapClone = (input: InterfaceDescriptor<unknown>, isSetByTemplate?: boolean) => {
            const cloned = input.clone(wrapInterfaceId(wrapWithId, input.props.id), isSetByTemplate)
            if (cloned.props.affectedOutputIds) {
                cloned.props.affectedOutputIds = cloned.props.affectedOutputIds.map((outputId) => wrapInterfaceId(wrapWithId, outputId))
            }
            return cloned
        }
        const output: InterfaceDescriptor<unknown>[] = []
        for (const input of this.interface) {
            if (this.claimedInputIds.indexOf(input.props.id) == -1) {
                output.push(wrapClone(input))
            } else if (this.includeClaimed) {
                output.push(wrapClone(input, true))
            }
        }
        this.output.emitIfChanged(output)
    }
}
